var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "19px",
      "height": "20px",
      "viewBox": "0 0 19 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xmlns:sketch": "http://www.bohemiancoding.com/sketch/ns"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke-width": "1",
      "fill-rule": "evenodd",
      "sketch:type": "MSPage"
    }
  }, [_c('g', {
    attrs: {
      "id": "user-management",
      "sketch:type": "MSArtboardGroup",
      "transform": "translate(-1537.000000, -77.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1538.81286,78.8095667 C1538.59524,78.8095667 1538.41882,78.9934815 1538.41882,79.2143793 L1538.41882,94.781175 C1538.41882,95.0047468 1538.60131,95.1859876 1538.8205,95.1859876 L1554.26713,95.1859876 C1554.48898,95.1859876 1554.66882,95.0037158 1554.66882,94.7871428 L1554.66882,85.191072 C1554.66882,84.9113368 1554.88655,84.6845667 1555.17724,84.6845667 L1555.41039,84.6845667 C1555.69119,84.6845667 1555.91882,84.9012633 1555.91882,85.1849745 L1555.91882,95.0595667 C1555.91882,95.8095667 1555.41882,96.3095667 1554.66882,96.3095667 L1538.41882,96.3095667 C1537.66882,96.3095667 1537.16882,95.8095667 1537.16882,95.0595667 L1537.16882,78.8095667 C1537.16882,78.0595667 1537.66882,77.5595667 1538.41882,77.5595667 L1548.29341,77.5595667 C1548.56978,77.5595667 1548.79382,77.7773 1548.79382,78.0679895 L1548.79382,78.3011438 C1548.79382,78.581938 1548.57712,78.8095667 1548.29341,78.8095667 L1538.81286,78.8095667 Z M1544.77998,88.0846007 L1545.82983,85.9390667 L1554.46567,77.3032328 C1554.66026,77.1086367 1554.96793,77.1124082 1555.15587,77.3148999 L1555.62689,77.8223917 C1555.81348,78.0234314 1555.80862,78.3420049 1555.61213,78.5378321 L1546.96958,87.1510809 L1544.77998,88.0846007 Z",
      "id": "Imported-Layers",
      "sketch:type": "MSShapeGroup"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }